import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'wt-ui';
import ReactMarkdown from 'react-markdown';

import i18next from '../../translations/i18n';

import DynamicText from '../../services/DynamicText';

const computeHeaderText = (fundData, filters) => {
  let text = '';
  const categoryKey = `${DynamicText.getCategoryKey(fundData)}_header`;
  if (i18next.exists(categoryKey)) {
    text = i18next.t(categoryKey);
  }
  return DynamicText.replaceText(text, fundData, filters);
};

const showIndexChangeDisclaimer = (fundData, filters) => {
  if (fundData.indexChangeDate) {
    const changeDate = new Date(fundData.indexChangeDate);
    const startDate = new Date(filters.startDate);
    const endDate = new Date(filters.endDate);

    return startDate <= changeDate || endDate <= changeDate;
  }

  return false;
};
const IndexChangeDisclaimer = (props) => {
  const { fundData, filters } = props;
  /* _eslint-disable */
  return (
    <>
      {showIndexChangeDisclaimer(fundData, filters) ? (
        <Box background="transparent" direction="row" justify="between">
          <ReactMarkdown source={DynamicText.replaceMarkdownText(i18next.t('disclaimerIndexChange'), fundData)} />
        </Box>
      ) : (
        ''
      )}
    </>
  );
  /* eslint-enable */
};

IndexChangeDisclaimer.propTypes = {
  fundData: PropTypes.shape({}).isRequired,
  filters: PropTypes.shape({}).isRequired,
};

const TableHeaderText = (props) => {
  const { fundData, filters } = props;
  return (
    <Box background="transparent" gap="small">
      <Box background="transparent" direction="row" justify="between">
        {computeHeaderText(fundData, filters)}
      </Box>
      <IndexChangeDisclaimer {...props} />
    </Box>
  );
};

TableHeaderText.propTypes = {
  fundData: PropTypes.shape({}).isRequired,
  filters: PropTypes.shape({}).isRequired,
};

export default TableHeaderText;
